const OutsideRedirect = ({ path }) => {
  if (typeof window !== "undefined") {
    window.location.replace(path);
  }
  return null;
};

export default OutsideRedirect;
